import orderService from "../../../services/orders/order.service";
import { orderActionTypes } from "../../actionTypes/orders/order.actionTypes";

// Add Order
export const addOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_ADD_ORDER });
    const response = await orderService.addOrder(orderData);
    console.log("🚀 ~ addOrder ~ response:", response);
    dispatch({
      type: orderActionTypes.ADD_ORDER_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Add order error:", ex.message);
    dispatch({ type: orderActionTypes.ADD_ORDER_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Update Order
export const updateOrder = (orderId, orderData) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_UPDATE_ORDER });
    const response = await orderService.updateOrder(orderId, orderData);
    dispatch({
      type: orderActionTypes.UPDATE_ORDER_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Update order error:", ex.message);
    dispatch({ type: orderActionTypes.UPDATE_ORDER_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Delete Order
export const deleteOrder = (orderId) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_DELETE_ORDER });
    await orderService.deleteOrder(orderId);
    dispatch({ type: orderActionTypes.DELETE_ORDER_SUCCESS });
  } catch (ex) {
    console.error("Delete order error:", ex.message);
    dispatch({ type: orderActionTypes.DELETE_ORDER_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Get Order by ID
export const getOrderById = (orderId) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_GET_ORDER_BY_ID });
    const response = await orderService.getOrderById(orderId);
    dispatch({
      type: orderActionTypes.GET_ORDER_BY_ID_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Get order by ID error:", ex.message);
    dispatch({ type: orderActionTypes.GET_ORDER_BY_ID_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Get Orders (List)
export const getOrders = () => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_GET_ORDERS });
    const response = await orderService.getOrders();
    dispatch({
      type: orderActionTypes.GET_ORDERS_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Get orders error:", ex.message);
    dispatch({ type: orderActionTypes.GET_ORDERS_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

export const updateOrderPaymentSuccess = (paymentData) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_UPDATE_ORDER_PAYMENT_SUCCESS });
    const response = await orderService.updateOrderPaymentSuccess(paymentData);
    dispatch({
      type: orderActionTypes.UPDATE_ORDER_PAYMENT_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Update order payment error:", ex.message);
    dispatch({
      type: orderActionTypes.UPDATE_ORDER_PAYMENT_FAILURE,
      error: ex.response?.data,
    });
    throw ex.response?.data;
  }
};

const orderActions = {
  addOrder,
  updateOrder,
  deleteOrder,
  getOrderById,
  getOrders,
  updateOrderPaymentSuccess,
};

export default orderActions;
